import { EnvironmentMarkerWithName } from '@gonfalon/environments/EnvironmentMarkerWithName';

import withProjectAndEnvironment from '#components/withProjectAndEnvironment';
import type { Environment } from '#utils/environments/records/Environment';
import { toMarkerEnv } from '#utils/environments/toMarkerEnv';

type CurrentEnvironmentProps = {
  environment?: Environment;
  className?: string;
  omitName?: boolean;
};

function BaseCurrentEnvironment({ environment, className, omitName }: CurrentEnvironmentProps) {
  return environment ? (
    <EnvironmentMarkerWithName className={className} env={toMarkerEnv(environment)} omitName={omitName} />
  ) : null;
}

export const CurrentEnvironment = withProjectAndEnvironment(BaseCurrentEnvironment);
